module.exports = __webpack_public_path__ + "media/images/dropdown-black-84ceb9ca2e20cbaf9ba08053212b8999.svg";